import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  height: 47px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 16px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img``;
Logo.displayName = 'Logo';

export const Points = styled.div`
  color: #ffffff;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  line-height: 56px;
  min-width: 70px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  color: #d0fb0c;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 200px;
  padding: 0 16px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  background: #1133e6;
  height: 80%;
  margin: 0 3px;
  width: 2px;
`;
Space.displayName = 'Space';

export const TeamContainer = styled.div`
  background-color: #0a1853;
  display: flex;
  height: 56px;
  overflow: hidden;
  z-index: 1;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamColor = styled.div`
  width: 16px;
`;
TeamColor.displayName = 'TeamColor';

export const TeamName = styled.div`
  color: #ffffff;
  font-size: 43px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.1em;
  line-height: 56px;
  padding: 0 16px;
  position: relative;
`;
TeamName.displayName = 'TeamName';

export const LeftTeamName = styled(TeamName)`
  background: linear-gradient(90deg, #000f71 0%, #1338f4 100%);
  box-shadow: inset -5px 0px 4px #1130f0;

  &:before {
    background: linear-gradient(-58deg, #000f71 -166%, #1338f4 85%);
    border-radius: 4px;
    content: '';
    height: 47px;
    position: absolute;
    right: -18px;
    top: 3px;
    transform: rotate(156deg) skewX(20deg) skewY(-34deg);
    width: 48px;
    z-index: -1;
  }
`;
LeftTeamName.displayName = 'LeftTeamName';
export const RightTeamName = styled(TeamName)`
  background: linear-gradient(270deg, #000f71 0%, #1338f4 100.34%);
  box-shadow: inset 5px 0px 4px #1130f0;

  &:before {
    background: linear-gradient(-58deg, #000f71 -166%, #1338f4 85%);
    border-radius: 4px;
    content: '';
    height: 47px;
    left: -18px;
    position: absolute;
    top: 3px;
    transform: rotate(351deg) skewX(20deg) skewY(-34deg);
    width: 48px;
    z-index: -1;
  }
`;
RightTeamName.displayName = 'RightTeamName';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #eceef2;
  display: flex;
  height: 56px;
  justify-content: center;
  margin-right: 8px;
  min-width: 230px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #0a1853;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.03em;
  line-height: 56px;
  margin-left: 24px;
  text-align: center;
`;
Timer.displayName = 'Timer';
